<div class="overlay-container" [ngClass]="{ 'show-side-bar': showHideSideBar, 'app': isApp }">
    <div class="container-close">
        <div [ngClass]="{ 'invisible': type !== 'user' }">
            <div *edpConditionalRegion="'pt.edp.edponline.profile.languages'">
                <edp-overlay-user-language></edp-overlay-user-language>
            </div>        
        </div>
        <button (click)="close()" class="btn btn-close" type="button" *ngIf="(type !== 'moreInfo') && (type !== 'mgm')">
            <i class="icon icon-edponline-Bop-071 icon-2x"  aria-hidden="true"></i>
        </button>
    </div>

    <!-- Add the component to be loaded inside the edp-overlay component bellow in the switch case statement. -->
    <span [ngSwitch]="type">
        <edp-overlay-user *ngSwitchCase="'user'" (showLoader)="showLoader($event)"></edp-overlay-user>
        <edp-overlay-more-info *ngSwitchCase="'moreInfo'" (closeSideBar)="close()" [origin]="origin"></edp-overlay-more-info>
        <edp-overlay-benefits *ngSwitchCase="'benefits'" (closeSideBar)="close()"></edp-overlay-benefits>
        <edp-overlay-mgm *ngSwitchCase="'mgm'" (closeSideBar)="close()" [origin]="origin"></edp-overlay-mgm>
        <edp-overlay-notifications
            *ngSwitchCase="'notifications'"
            (closeSideBar)="close()"
            [overlayChagesListner]="overlayStatusChanged"
        ></edp-overlay-notifications>

        <edp-overlay-push-configs *ngSwitchCase="'push-configs'" (closeSideBar)="close()"></edp-overlay-push-configs>
    </span>
</div>
